// extracted by mini-css-extract-plugin
export var aboutRow = "about-module--about-row--wPrn6";
export var aboutColumns = "about-module--about-columns--1gRck";
export var imageColumn = "about-module--image-column--1aa5O";
export var textColumn = "about-module--text-column--1MwC5";
export var textBody = "about-module--text-body--2BvNy";
export var team = "about-module--team--3L_mB";
export var teacher = "about-module--teacher--1P-Kz";
export var aboutContent = "about-module--about-content--2wVLI";